import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const SITE_URL = "https://digitaladdoctor.co.uk";
export const FALLBACK_EMAIL = "freya@digitaladdoctor.co";

export const http = axios.create({ baseURL: API, withCredentials: true });

export function formatError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || "").replace("Value error, ", "")).join(" ");
  return String(d);
}

const get = (url) => () => http.get(url).then((r) => r.data);

export function useSettings() {
  const q = useQuery({ queryKey: ["settings"], queryFn: get("/settings"), retry: 1 });
  return q.data && typeof q.data === "object" ? q.data : {};
}

export function useContent(col) {
  const q = useQuery({ queryKey: ["content", col], queryFn: get(`/content/${col}`), retry: 1 });
  return { items: Array.isArray(q.data) ? q.data : [], loading: q.isLoading };
}

export function useItem(col, slug) {
  const q = useQuery({ queryKey: ["content", col, slug], queryFn: get(`/content/${col}/${slug}`), retry: false });
  return { item: q.data || null, loading: q.isLoading, error: q.isError };
}
